/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddAgencyDto,
    AddAgencyUserDto,
    IdResponse,
    UpdateAgencyDto,
    UpdateAgencyUserDto,
    UpdateAgencyUserPasswordRequest,
} from '../models';

export interface AgencyApiControllerActivateAgencyRequest {
    agencyId: string;
}

export interface AgencyApiControllerActivateAgencyUserRequest {
    agencyId: string;
    userId: string;
}

export interface AgencyApiControllerAddAgencyRequest {
    addAgencyDto: AddAgencyDto;
}

export interface AgencyApiControllerAddAgencyUserRequest {
    agencyId: string;
    addAgencyUserDto: AddAgencyUserDto;
}

export interface AgencyApiControllerDisableAgencyRequest {
    agencyId: string;
}

export interface AgencyApiControllerDisableAgencyUserRequest {
    agencyId: string;
    userId: string;
}

export interface AgencyApiControllerRemoveAgencyUserRequest {
    agencyId: string;
    userId: string;
}

export interface AgencyApiControllerUpdateAgencyRequest {
    agencyId: string;
    updateAgencyDto: UpdateAgencyDto;
}

export interface AgencyApiControllerUpdateAgencyUserRequest {
    agencyId: string;
    userId: string;
    updateAgencyUserDto: UpdateAgencyUserDto;
}

export interface AgencyApiControllerUpdateAgencyUserPasswordRequest {
    agencyId: string;
    userId: string;
    updateAgencyUserPasswordRequest: UpdateAgencyUserPasswordRequest;
}

/**
 * 
 */
export class AgencyApi extends runtime.BaseAPI {

    /**
     */
    async agencyApiControllerActivateAgencyRaw(requestParameters: AgencyApiControllerActivateAgencyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerActivateAgency.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}:activate`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async agencyApiControllerActivateAgency(requestParameters: AgencyApiControllerActivateAgencyRequest): Promise<void> {
        await this.agencyApiControllerActivateAgencyRaw(requestParameters);
    }

    /**
     */
    async agencyApiControllerActivateAgencyUserRaw(requestParameters: AgencyApiControllerActivateAgencyUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerActivateAgencyUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling agencyApiControllerActivateAgencyUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}/users/{userId}:activate`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async agencyApiControllerActivateAgencyUser(requestParameters: AgencyApiControllerActivateAgencyUserRequest): Promise<void> {
        await this.agencyApiControllerActivateAgencyUserRaw(requestParameters);
    }

    /**
     */
    async agencyApiControllerAddAgencyRaw(requestParameters: AgencyApiControllerAddAgencyRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.addAgencyDto === null || requestParameters.addAgencyDto === undefined) {
            throw new runtime.RequiredError('addAgencyDto','Required parameter requestParameters.addAgencyDto was null or undefined when calling agencyApiControllerAddAgency.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addAgencyDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async agencyApiControllerAddAgency(requestParameters: AgencyApiControllerAddAgencyRequest): Promise<IdResponse> {
        const response = await this.agencyApiControllerAddAgencyRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async agencyApiControllerAddAgencyUserRaw(requestParameters: AgencyApiControllerAddAgencyUserRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerAddAgencyUser.');
        }

        if (requestParameters.addAgencyUserDto === null || requestParameters.addAgencyUserDto === undefined) {
            throw new runtime.RequiredError('addAgencyUserDto','Required parameter requestParameters.addAgencyUserDto was null or undefined when calling agencyApiControllerAddAgencyUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}/users`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addAgencyUserDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async agencyApiControllerAddAgencyUser(requestParameters: AgencyApiControllerAddAgencyUserRequest): Promise<IdResponse> {
        const response = await this.agencyApiControllerAddAgencyUserRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async agencyApiControllerDisableAgencyRaw(requestParameters: AgencyApiControllerDisableAgencyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerDisableAgency.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}:disable`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async agencyApiControllerDisableAgency(requestParameters: AgencyApiControllerDisableAgencyRequest): Promise<void> {
        await this.agencyApiControllerDisableAgencyRaw(requestParameters);
    }

    /**
     */
    async agencyApiControllerDisableAgencyUserRaw(requestParameters: AgencyApiControllerDisableAgencyUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerDisableAgencyUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling agencyApiControllerDisableAgencyUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}/users/{userId}:disable`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async agencyApiControllerDisableAgencyUser(requestParameters: AgencyApiControllerDisableAgencyUserRequest): Promise<void> {
        await this.agencyApiControllerDisableAgencyUserRaw(requestParameters);
    }

    /**
     */
    async agencyApiControllerRemoveAgencyUserRaw(requestParameters: AgencyApiControllerRemoveAgencyUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerRemoveAgencyUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling agencyApiControllerRemoveAgencyUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}/users/{userId}`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async agencyApiControllerRemoveAgencyUser(requestParameters: AgencyApiControllerRemoveAgencyUserRequest): Promise<void> {
        await this.agencyApiControllerRemoveAgencyUserRaw(requestParameters);
    }

    /**
     */
    async agencyApiControllerUpdateAgencyRaw(requestParameters: AgencyApiControllerUpdateAgencyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerUpdateAgency.');
        }

        if (requestParameters.updateAgencyDto === null || requestParameters.updateAgencyDto === undefined) {
            throw new runtime.RequiredError('updateAgencyDto','Required parameter requestParameters.updateAgencyDto was null or undefined when calling agencyApiControllerUpdateAgency.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateAgencyDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async agencyApiControllerUpdateAgency(requestParameters: AgencyApiControllerUpdateAgencyRequest): Promise<void> {
        await this.agencyApiControllerUpdateAgencyRaw(requestParameters);
    }

    /**
     */
    async agencyApiControllerUpdateAgencyUserRaw(requestParameters: AgencyApiControllerUpdateAgencyUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerUpdateAgencyUser.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling agencyApiControllerUpdateAgencyUser.');
        }

        if (requestParameters.updateAgencyUserDto === null || requestParameters.updateAgencyUserDto === undefined) {
            throw new runtime.RequiredError('updateAgencyUserDto','Required parameter requestParameters.updateAgencyUserDto was null or undefined when calling agencyApiControllerUpdateAgencyUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}/users/{userId}`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateAgencyUserDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async agencyApiControllerUpdateAgencyUser(requestParameters: AgencyApiControllerUpdateAgencyUserRequest): Promise<void> {
        await this.agencyApiControllerUpdateAgencyUserRaw(requestParameters);
    }

    /**
     */
    async agencyApiControllerUpdateAgencyUserPasswordRaw(requestParameters: AgencyApiControllerUpdateAgencyUserPasswordRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.agencyId === null || requestParameters.agencyId === undefined) {
            throw new runtime.RequiredError('agencyId','Required parameter requestParameters.agencyId was null or undefined when calling agencyApiControllerUpdateAgencyUserPassword.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling agencyApiControllerUpdateAgencyUserPassword.');
        }

        if (requestParameters.updateAgencyUserPasswordRequest === null || requestParameters.updateAgencyUserPasswordRequest === undefined) {
            throw new runtime.RequiredError('updateAgencyUserPasswordRequest','Required parameter requestParameters.updateAgencyUserPasswordRequest was null or undefined when calling agencyApiControllerUpdateAgencyUserPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/agencies/{agencyId}/users/{userId}:updatePassword`.replace(`{${"agencyId"}}`, encodeURIComponent(String(requestParameters.agencyId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateAgencyUserPasswordRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async agencyApiControllerUpdateAgencyUserPassword(requestParameters: AgencyApiControllerUpdateAgencyUserPasswordRequest): Promise<void> {
        await this.agencyApiControllerUpdateAgencyUserPasswordRaw(requestParameters);
    }

}
